module.exports = __webpack_public_path__ + "static/media/p2.c0aefac9.jpg";